module.exports = __webpack_public_path__ + "static/media/VEVA-Cube-Glow.135db007.png";